// @core/api/endpoints/document/delegate_stage_action.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DelegateStageActionRequest,
  PipelineExecutionResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Delegate stage action
 * Delegates the current user's pipeline action to another actor. Only allowed if the stage has allow_delegation enabled.
 */
export async function DelegateStageAction(
  target_type: string,
  target_id: string,
  execution_id: string,
  data: DelegateStageActionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipeline-executions/:execution_id/delegate`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
